import { ConnectorInstructions } from './types'

export const CONNECTOR_INSTRUCTIONS: Record<string, ConnectorInstructions> = {
  ins_115699: {
    text: 'Before configuring this connection, please:',
    steps: [
      'Log in directly to your Morgan Stanley portal <a href="https://mso.morganstanleyclientserv.com/atrium/#/self-service/security-center" target="_blank" rel="noopener noreferrer">here</a>',
      'Click Account Access → Allow third-party data sharing',
      'Select YES',
      'Update',
    ],
    confirmationText: 'I have allowed third-party data sharing',
  },
}
